import React, { forwardRef } from "react";
import styles from "../css/input-field.module.css";

const InputField = forwardRef((props, ref) => {
  const {
    type,
    name,
    placeholder,
    inputRef,
    handleEnterKey,
    testId,
    onChange,
    ...otherProps
  } = props;

  return (
    <div className={styles.inputField}>
      <input
        {...otherProps}
        className={styles.input}
        type={type}
        name={name}
        placeholder={placeholder}
        ref={ref}
        data-test-id={testId}
        onKeyUp={handleEnterKey}
        onChange={onChange}
      />
    </div>
  );
});

export default InputField;
